/*
*
* Hellosite
*
*/

$( document ).ready(function() {
   var bodyControl = document.getElementById("page-main-content");
   bodyControl.style.minHeight = (window.innerHeight-400) + 'px';
   
   var loginPageControl = document.getElementById("login-page");
   if(loginPageControl == undefined){
   }else{
	   var marginTop = ((window.innerHeight-400-100)/2);
	   if(marginTop < 130){
	   		marginTop = 130;
	   }
	   loginPageControl.style.marginTop = marginTop+'px';
   }
   if(window.location.pathname == 'collections' || window.location.pathname == '/collections' || window.location.pathname == '/collections/'){
   		window.location.href = '/';
   }
});
$(document).on("click", ".btn-menu-canvas", function() {
    $('#mobile-boostrap').toggle();
});